module.exports = __webpack_public_path__ + "media/images/games/fifa-20/square-48a8d220ead7540d9b214c07d3e7d53b.jpg";